import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import { Helmet } from 'react-helmet';
import "./PortfolioPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import {Link} from "react-router-dom";
import {portfolio,PortfolioCards} from "../../data";
import ProjectCards from "../../Common/Tab";

//import { Link } from 'react-router-dom';

function App() {
  return <X03PortfolioPage {...x03PortfolioPageData} />;
}

export default App;

function X03PortfolioPage(props) {
  const {
    ourProjects,
    rectangle76,
    text80,
    text802,
    text803,
    text804,
    text805,
    //headerWithBackgroundProps,
    group104Props,
    //group89Props,
    projectCard3Props,
    projectCard32Props,
    projectCard33Props,
    projectCard34Props,
    projectCard35Props,
    projectCard36Props,
    projectCard3Props2,
    projectCard32Props2,
    projectCard33Props2,
    projectCard34Props2,
    projectCard35Props2,
    projectCard36Props2,
    buttonProps,
    projectCard3Props3,
    projectCard32Props3,
    projectCard33Props3,
    projectCard34Props3,
    projectCard35Props3,
    projectCard36Props3,
    footerProps,
  } = props;

  return (
    <div className="ppd-container-center-horizontal">
      <Helmet>
        <title>Webuildd Construction | Projects</title>
        <meta name="keywords" content="completed Residential construction, completed commercial construction, interior designing, construction in-progress" />
        <meta name="description" content="Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency." />
      </Helmet>
      <div className="ppd-x03-portfolio-page-desktop">
        {/* <HeaderWithBackground72 {...headerWithBackgroundProps} /> */}
        <NavBar />
        <div className="ppd-frame-1572">
          <h1 className="ppd-title ppd-valign-text-middle ppd-typographyheadlineh2-extrabold-40">{ourProjects}</h1>
          {/* <img className="ppd-rectangle-76" src={rectangle76} /> */}
          <img className="ppd-rectangle-76" src={portfolio.PortfolioHeader} alt="Webuildd Projects"/>
          <div className="ppd-text-46 ppd-typographybody16-regular">
            <p>{text80}</p>
            <p>{text802}</p>
            <p>{text803}</p>
            <p>{text804}</p>
            <p>{text805}</p>
          </div>
          {/* <Group104
            apartments={group104Props.apartments}
            buildiings={group104Props.buildiings}
            place={group104Props.place}
            living={group104Props.living}
            group139Props={group104Props.group139Props}
          /> */}
                 <ProjectCards />
          {/* <div className="ppd-group-159">
            <div className="ppd-overlap-group">
              <div className="ppt-frame-1609"></div> */}
       
              {/* <Group89
                line4={group89Props.line4}
                line5={group89Props.line5}
                line6={group89Props.line6}
                line7={group89Props.line7}
                line8={group89Props.line8}
              /> */}
                {/* <div className="ppd-flex-row"> */}
                  {/* {
                    PortfolioCards.map(item =>(
                      <div className={`ppd-${item.divClass}`}>
                        {
                          item.divData.map( itemdata =>(
                            <ProjectCard3
                              rectangle62={itemdata.rectangle62}
                              className={itemdata.className}
                              group99Props={itemdata.group99Props}
                            />
                          ))
                        }
                      </div>
                    ))
                  } */}
{/*                   
                  <div className="ppd-flex-col">
                    <ProjectCard3
                      rectangle62={projectCard3Props.rectangle62}
                      group99Props={projectCard3Props.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard32Props.rectangle62}
                      className={projectCard32Props.className}
                      group99Props={projectCard32Props.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard33Props.rectangle62}
                      className={projectCard33Props.className}
                      group99Props={projectCard33Props.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard34Props.rectangle62}
                      className={projectCard34Props.className}
                      group99Props={projectCard34Props.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard35Props.rectangle62}
                      className={projectCard35Props.className}
                      group99Props={projectCard35Props.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard36Props.rectangle62}
                      className={projectCard36Props.className}
                      group99Props={projectCard36Props.group99Props}
                    />
                  </div>
                  <div className="ppd-flex-col-1">
                    <ProjectCard3
                      rectangle62={projectCard3Props2.rectangle62}
                      group99Props={projectCard3Props2.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard32Props2.rectangle62}
                      className={projectCard32Props2.className}
                      group99Props={projectCard32Props2.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard33Props2.rectangle62}
                      className={projectCard33Props2.className}
                      group99Props={projectCard33Props2.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard34Props2.rectangle62}
                      className={projectCard34Props2.className}
                      group99Props={projectCard34Props2.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard35Props2.rectangle62}
                      className={projectCard35Props2.className}
                      group99Props={projectCard35Props2.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard36Props2.rectangle62}
                      className={projectCard36Props2.className}
                      group99Props={projectCard36Props2.group99Props}
                    />
                    <Button62>{buttonProps.children}</Button62>
                  </div>
                  <div className="ppd-flex-col-2">
                    <ProjectCard3
                      rectangle62={projectCard3Props3.rectangle62}
                      group99Props={projectCard3Props3.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard32Props3.rectangle62}
                      className={projectCard32Props3.className}
                      group99Props={projectCard32Props3.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard33Props3.rectangle62}
                      className={projectCard33Props3.className}
                      group99Props={projectCard33Props3.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard34Props3.rectangle62}
                      className={projectCard34Props3.className}
                      group99Props={projectCard34Props3.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard35Props3.rectangle62}
                      className={projectCard35Props3.className}
                      group99Props={projectCard35Props3.group99Props}
                    />
                    <ProjectCard3
                      rectangle62={projectCard36Props3.rectangle62}
                      className={projectCard36Props3.className}
                      group99Props={projectCard36Props3.group99Props}
                    />
                  </div> */}
                {/* </div> */}
                {/* <Footer32 {...footerProps} /> */}
             
            {/* </div>
          </div> */}
          <Footer />
        </div>
      </div>
      
    </div>
  );
}


// function HeaderWithBackground72(props) {
//   const {
//     unselectedI2601262,
//     unselectedI26012622,
//     text1,
//     unselectedI26012623,
//     unselectedI26012624,
//     unselectedI26012625,
//     unselectedI26012626,
//     unselectedI26012627,
//     group86Props,
//     getAQuoteButton22Props,
//   } = props;

//   return (
//     <div className="ppd-header-with-background">
//       <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
//       <div className="ppd-frame-34">
//         <div className="ppd-frame-27">
//           <Link to="/">
//           <div className="ppd-unselected-i2601256 ppd-valign-text-middle ppd-typography-body-smalltext-14-regular">
//             {unselectedI2601262}
//           </div>
//           </Link>
//           <Link to="/about">
//           <div className="ppd-unselected-i2601256-1 ppd-valign-text-middle ppd-typography-body-smalltext-14-regular">
//             {unselectedI26012622}
//           </div>
//           </Link>
//           <div className="ppd-selected">
//             <div className="ppd-overlap-group-1">
//               <div className="ppd-rectangle-61"></div>
//               <div className="ppd-text-47 ppd-valign-text-middle">{text1}</div>
//             </div>
//           </div>
//           <Link to="/video">
//           <div className="ppd-unselected-i2601256-2 ppd-valign-text-middle ppd-typography-body-smalltext-14-regular">
//             {unselectedI26012623}
//           </div>
//           </Link>
//           <Link to="/insight">
//           <div className="ppd-unselected-i2601256-3 ppd-valign-text-middle ppd-typography-body-smalltext-14-regular">
//             {unselectedI26012624}
//           </div>
//           </Link>
//           <Link to="/blog">
//           <div className="ppd-unselected-i2601256-4 ppd-valign-text-middle ppd-typography-body-smalltext-14-regular">
//             {unselectedI26012625}
//           </div>
//           </Link>
//           <Link to="/faq">
//           <div className="ppd-unselected-i2601256-5 ppd-valign-text-middle ppd-typography-body-smalltext-14-regular">
//             {unselectedI26012626}
//           </div>
//           </Link>
//           <Link to="/contactus">
//           <div className="ppd-unselected-i2601256-6 ppd-valign-text-middle ppd-typography-body-smalltext-14-regular">
//             {unselectedI26012627}
//           </div>
//           </Link>
//         </div>
//         <GetAQuoteButton22>{getAQuoteButton22Props.children}</GetAQuoteButton22>
//       </div>
//     </div>
//   );
// }


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="ppd-group-86">
      <White src={whiteProps.src} />
      <img className="ppd-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="ppd-white">
      <img className="ppd-vector" src={src} />
    </div>
  );
}


function GetAQuoteButton22(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(i2601256564120TimelineData);
  }, []);

  return (
    <div className="ppd-i26012565-64120 ppd-component ppd-component-wrapper ppd-not-ready">
      <div className="ppd-master-button-jxmI79">
        <div className="ppd-button-i2601256564-iESC2H ppd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const i2601256564120TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".ppd-i26012565-64120",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function Group104(props) {
  const { apartments, buildiings, place, living, group139Props } = props;

  return (
    <div className="ppd-group-104">
      <Group139>{group139Props.children}</Group139>
      <div className="ppd-apartments ppd-typographybodycaption-14-semi-bold">{apartments}</div>
      <div className="ppd-buildiings ppd-typographybodycaption-14-semi-bold">{buildiings}</div>
      <div className="ppd-place ppd-typographybodycaption-14-semi-bold">{place}</div>
      <div className="ppd-living ppd-typographybodycaption-14-semi-bold">{living}</div>
    </div>
  );
}


function Group139(props) {
  const { children } = props;

  return (
    <div className="ppd-group-139">
      <div className="ppd-overlap-group-2">
        <div className="ppd-rectangle-46"></div>
        <div className="ppd-price">{children}</div>
      </div>
    </div>
  );
}


function Group89(props) {
  const { line4, line5, line6, line7, line8 } = props;

  return (
    <div className="ppd-group-89">
      <img className="ppd-line-4" src={line4} />
      <img className="ppd-line" src={line5} />
      <img className="ppd-line" src={line6} />
      <img className="ppd-line" src={line7} />
      <img className="ppd-line-8" src={line8} />
    </div>
  );
}


function ProjectCard3(props) {
  const { rectangle62, className, group99Props } = props;

  return (
    <Link to="/projectdetails">
    <div className={`project-card ppd-${className || ""}`}>
      <img className="ppd-rectangle-62" src={rectangle62} />
      <Group99 text1={group99Props.text1} surname={group99Props.surname} />
    </div>
    </Link>
  );
}


function Group99(props) {
  const { text1, surname } = props;

  return (
    <div className="ppd-group-99">
      <div className="ppd-text ppd-valign-text-middle ppd-typographyheadlineh4-extrabold-24">{text1}</div>
      <p className="ppd-surname ppd-typography-body-smalltext-14-regular">{surname}</p>
    </div>
  );
}


function Button62(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x26012541TimelineData);
  }, []);

  return (
    <div className="ppd-x26012541 ppd-component ppd-component-wrapper ppd-not-ready">
      <div className="ppd-master-button-ak6aLj">
        <div className="ppd-button-i2601254151-8Gvxed ppd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x26012541TimelineData = [
  {
    initial_state_name: "Property-1=Tertiary",
    root_element: ".ppd-x26012541",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


// function Footer32(props) {
//   const {
//     overlapGroup1,
//     vector,
//     vector2,
//     group862Props,
//     facebookAppSymbolProps,
//     twitterProps,
//     frame5Props,
//     frame6Props,
//     frame7Props,
//   } = props;

//   return (
//     <div className="ppd-footer">
//       <div className="ppd-frame-1585">
//         <div className="ppd-frame-1578">
//           <Group86222 group85={group862Props.group85} whiteProps={group862Props.whiteProps} />
//           <div className="ppd-frame-1584">
//             <Group324 />
//             <div className="ppd-frame-1583">
//               <FacebookAppSymbol3 src={facebookAppSymbolProps.src} />
//               <div className="ppd-instagram">
//                 <div className="ppd-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="ppd-vector-1" src={vector} />
//                   <img className="ppd-vector-2" src={vector2} />
//                 </div>
//               </div>
//               <Twitter3 src={twitterProps.src} />
//             </div>
//           </div>
//         </div>
//         <Frame53 text40={frame5Props.text40} frame4Props={frame5Props.frame4Props} />
//         <Frame6
//           text48={frame6Props.text48}
//           frame42Props={frame6Props.frame42Props}
//           frame422Props={frame6Props.frame422Props}
//         />
//       </div>
//       <Frame7 text56={frame7Props.text56} frame4Props={frame7Props.frame4Props} />
//     </div>
//   );
// }


function Group86222(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="ppd-group-86-1">
      <White src={whiteProps.src} />
      <img className="ppd-group-85-1" src={group85} />
    </div>
  );
}


function Group324() {
  return (
    <div className="ppd-group-32">
      <div className="ppd-group-189">
        <div className="ppd-map-pin-1">
          <div className="ppd-overlap-group1-1">
            <img
              className="ppd-vector-3"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-167@2x.svg"
            />
          </div>
        </div>
        <p className="ppd-text-19 ppd-typographybody16-regular">
          #8, 105, Vishal Park Word, 3rd Cross, Cambridge Road Ulsoor, Bangalore, Bengaluru, Karnataka 560008
        </p>
      </div>
      <div className="ppd-group-18">
        <div className="ppd-phone">
          <img
            className="ppd-vector-4"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-168@2x.svg"
          />
        </div>
        <div className="ppd-text-2 ppd-valign-text-middle ppd-typographybody16-regular">+91 8976535221, +91 8755645342</div>
      </div>
      <div className="ppd-group-18">
        <div className="ppd-mail">
          <div className="ppd-overlap-group1-2">
            <img
              className="ppd-vector-5"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-170@2x.svg"
            />
          </div>
        </div>
        <div className="ppd-text-2 ppd-valign-text-middle ppd-typographybody16-regular">contact@webuild.com</div>
      </div>
    </div>
  );
}


function FacebookAppSymbol3(props) {
  const { src } = props;

  return (
    <div className="ppd-facebook-app-symbol">
      <img className="ppd-f-1" src={src} />
    </div>
  );
}


function Twitter3(props) {
  const { src } = props;

  return (
    <div className="ppd-twitter">
      <img className="ppd-vector-6" src={src} />
    </div>
  );
}


function Frame53(props) {
  const { text40, frame4Props } = props;

  return (
    <div className="ppd-frame-5">
      <div className="ppd-text-22 ppd-valign-text-middle ppd-typographyheadlineh5-extrabold-20">{text40}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


function Frame4(props) {
  const { text41, text42, text43, text44, text45, text46, text47 } = props;

  return (
    <div className="ppd-frame-4">
      <div className="ppd-text-1 ppd-valign-text-middle ppd-typographybody16-regular">{text41}</div>
      <div className="ppd-text-3 ppd-valign-text-middle ppd-typographybody16-regular">{text42}</div>
      <div className="ppd-text-3 ppd-valign-text-middle ppd-typographybody16-regular">{text43}</div>
      <div className="ppd-text-3 ppd-valign-text-middle ppd-typographybody16-regular">{text44}</div>
      <div className="ppd-text-3 ppd-valign-text-middle ppd-typographybody16-regular">{text45}</div>
      <div className="ppd-text-3 ppd-valign-text-middle ppd-typographybody16-regular">{text46}</div>
      <div className="ppd-text-3 ppd-valign-text-middle ppd-typographybody16-regular">{text47}</div>
    </div>
  );
}


function Frame6(props) {
  const { text48, frame42Props, frame422Props } = props;

  return (
    <div className="ppd-frame-6">
      <div className="ppd-text-30 ppd-valign-text-middle ppd-typographyheadlineh5-extrabold-20">{text48}</div>
      <div className="ppd-frame-1577">
        <Frame42
          text49={frame42Props.text49}
          text50={frame42Props.text50}
          place={frame42Props.place}
          text51={frame42Props.text51}
          text52={frame42Props.text52}
        />
        <Frame42
          text49={frame422Props.text49}
          text50={frame422Props.text50}
          place={frame422Props.place}
          text51={frame422Props.text51}
          text52={frame422Props.text52}
          className={frame422Props.className}
        />
      </div>
    </div>
  );
}


function Frame42(props) {
  const { text49, text50, place, text51, text52, className } = props;

  return (
    <div className={`frame-4-1 ${className || ""}`}>
      <div className="ppd-text-31 ppd-valign-text-middle ppd-overpass-extra-bold-white-16px">{text49}</div>
      <div className="ppd-frame-1580">
        <div className="ppd-text-3-1 ppd-valign-text-middle ppd-typographybody16-regular">{text50}</div>
        <div className="ppd-place-1 ppd-valign-text-middle ppd-typographybody16-regular">{place}</div>
        <div className="ppd-text-33 ppd-valign-text-middle ppd-typographybody16-regular">{text51}</div>
        <div className="ppd-text-34 ppd-valign-text-middle ppd-typographybody16-regular">{text52}</div>
      </div>
    </div>
  );
}


function Frame7(props) {
  const { text56, frame4Props } = props;

  return (
    <div className="ppd-frame-7">
      <div className="ppd-text-38 ppd-valign-text-middle ppd-typographyheadlineh5-extrabold-20">{text56}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: whiteData,
};

const getAQuoteButton22Data = {
    children: "GET A QUOTE",
};

// const headerWithBackground72Data = {
//     unselectedI2601262: "HOME",
//     unselectedI26012622: "ABOUT US",
//     text1: "PROJECTS",
//     unselectedI26012623: "VIDEOS",
//     unselectedI26012624: "INSIGHTS",
//     unselectedI26012625: "BLOGS",
//     unselectedI26012626: "FAQ’S",
//     unselectedI26012627: "CONTACT US",
//     group86Props: group86Data,
//     getAQuoteButton22Props: getAQuoteButton22Data,
// };

const group139Data = {
    children: "ALL",
};

const group104Data = {
    apartments: "APARTMENTS",
    buildiings: "BUILDIINGS",
    place: "INTERIOR",
    living: "LIVING",
    group139Props: group139Data,
};

const group89Data = {
    line4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    line5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    line6: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    line7: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    line8: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
};

const group99Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard3Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62@2x.png",
    group99Props: group99Data,
};

const group992Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard32Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-1@2x.png",
    className: "ppd-project-card-1",
    group99Props: group992Data,
};

const group993Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard33Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-2@2x.png",
    className: "ppd-project-card-2",
    group99Props: group993Data,
};

const group994Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard34Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-2@2x.png",
    className: "ppd-project-card-1",
    group99Props: group994Data,
};

const group995Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard35Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-2@2x.png",
    className: "ppd-project-card-1",
    group99Props: group995Data,
};

const group996Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard36Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-2@2x.png",
    className: "ppd-project-card-1",
    group99Props: group996Data,
};

const group997Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard37Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-5@2x.png",
    group99Props: group997Data,
};

const group998Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard38Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-7@2x.png",
    className: "ppd-project-card-1",
    group99Props: group998Data,
};

const group999Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard39Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-3@2x.png",
    className: "ppd-project-card-2",
    group99Props: group999Data,
};

const group9910Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard310Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-3@2x.png",
    className: "ppd-project-card-1",
    group99Props: group9910Data,
};

const group9911Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard311Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-3@2x.png",
    className: "ppd-project-card-1",
    group99Props: group9911Data,
};

const group9912Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard312Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-3@2x.png",
    className: "ppd-project-card-1",
    group99Props: group9912Data,
};

const button62Data = {
    children: "MORE PROJECTS",
};

const group9913Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard313Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-6@2x.png",
    group99Props: group9913Data,
};

const group9914Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard314Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-8@2x.png",
    className: "ppd-project-card-1",
    group99Props: group9914Data,
};

const group9915Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard315Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-4@2x.png",
    className: "ppd-project-card-2",
    group99Props: group9915Data,
};

const group9916Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard316Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-4@2x.png",
    className: "ppd-project-card-1",
    group99Props: group9916Data,
};

const group9917Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard317Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-4@2x.png",
    className: "ppd-project-card-1",
    group99Props: group9917Data,
};

const group9918Data = {
    text1: "Project Name",
    surname: "Small description about the project",
};

const projectCard318Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-4@2x.png",
    className: "ppd-project-card-1",
    group99Props: group9918Data,
};

const white2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-88@2x.svg",
};

const group86222Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
    whiteProps: white2Data,
};

const facebookAppSymbol3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-5@2x.svg",
};

const twitter3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame4Data = {
    text41: "About Us",
    text42: "Projects",
    text43: "Videos",
    text44: "Packages",
    text45: "Insights",
    text46: "Blogs",
    text47: "FAQ’s",
};

const frame53Data = {
    text40: "Quick Links",
    frame4Props: frame4Data,
};

const frame42Data = {
    text49: "Construction",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
};

const frame422Data = {
    text49: "Interior",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
    className: "ppd-frame-5-1",
};

const frame6Data = {
    text48: "Packages",
    frame42Props: frame42Data,
    frame422Props: frame422Data,
};

const frame43Data = {
    text41: "BBEMP",
    text42: "BWSSB",
    text43: "BESCOM",
    text44: "Procedure",
    text45: "Vaastu",
    text46: "Bye Laws",
    text47: "Tips & Ideas",
};

const frame7Data = {
    text56: "Insights",
    frame4Props: frame43Data,
};

// const footer32Data = {
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-171@2x.svg",
//     vector: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-238@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-228@2x.svg",
//     group862Props: group86222Data,
//     facebookAppSymbolProps: facebookAppSymbol3Data,
//     twitterProps: twitter3Data,
//     frame5Props: frame53Data,
//     frame6Props: frame6Data,
//     frame7Props: frame7Data,
// };

const x03PortfolioPageData = {
    ourProjects: "Our Projects",
    rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-1@1x.png",
    text80: "The WeBuildd team of highly skilled and dedicated professionals has been delivering successful projects across all asset classes including, industrial, manufacturing, biotech, residential, healthcare, education, mixed-use, and retail for decades.",
    text802: "We believe that quality construction is much more than choosing materials and craftsmanship. We strive to create an experience our clients can enjoy throughout the construction process. And we deliver beyond the expected so that you have the best possible solution.",
    text803: "As evidenced from our projects, we pay strict attention to small details. As a third-generation family-owned construction firm, we have evolved into a highly-regarded, fully integrated construction firm because our commitment to exceptional quality has never wavered. We are proud of our reputation for quality work and on-time delivery of projects.",
    text804: "We are consistently bringing our clients appropriate and more efficient building solutions in Bengaluru and beyond. We are environmentally responsible. And we have also developed strong working relationships with vendors, which helps minimize costs and unnecessary delays.",
    text8025: "Look at our featured projects below:",
    //headerWithBackgroundProps: headerWithBackground72Data,
    group104Props: group104Data,
    group89Props: group89Data,
    projectCard3Props: projectCard3Data,
    projectCard32Props: projectCard32Data,
    projectCard33Props: projectCard33Data,
    projectCard34Props: projectCard34Data,
    projectCard35Props: projectCard35Data,
    projectCard36Props: projectCard36Data,
    projectCard3Props2: projectCard37Data,
    projectCard32Props2: projectCard38Data,
    projectCard33Props2: projectCard39Data,
    projectCard34Props2: projectCard310Data,
    projectCard35Props2: projectCard311Data,
    projectCard36Props2: projectCard312Data,
    buttonProps: button62Data,
    projectCard3Props3: projectCard313Data,
    projectCard32Props3: projectCard314Data,
    projectCard33Props3: projectCard315Data,
    projectCard34Props3: projectCard316Data,
    projectCard35Props3: projectCard317Data,
    projectCard36Props3: projectCard318Data,
    //footerProps: footer32Data,
};

